import baseAPI from '../../axiosApi'

const api={
    list:'/api-ir/bachelor/practice/page',
    add:'/api-ir/bachelor/practice/add',
    update:'/api-ir/bachelor/practice/edit',
    info:'/api-ir/bachelor/practice/info/',
    del:'/api-ir/bachelor/practice/delete/',
}
// 查询课程列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增课程
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改课程
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询课程信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除课程
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
